export { getAnalytics } from "./analyticsWrapper";
export { setLandingPageAnalytics, type PageName } from "./IAnalytics";
